// components/EditMerchandiseItemForm.js
import React, { useState } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import './EditMerchandiseItemForm.css';

const EDIT_MERCH_ITEM = gql`
  mutation EditMerchandiseItem($input: EditMerchandiseItemInput!) {
    EditMerchandiseItem(input: $input) {
      id
      title
      description
      longDescription
      price
      brand
      stockQuantity
      categoryId
      weight
      length
      width
      height
      barcode
      tags
      hasVariants
    }
  }
`;

const GET_CATEGORIES = gql`
  query GetCategories($merchandisePageId: ID!) {
    GetCategories(merchandisePageId: $merchandisePageId) {
      id
      name
    }
  }
`;

const EditMerchandiseItemForm = ({ onSuccess }) => {
  const { state } = useLocation();
  const item = state?.item;
  console.log(state)
  const [formData, setFormData] = useState({
    id: item.id,
    title: item.title || '',
    description: item.description || '',
    longDescription: item.longDescription || '',
    price: item.price || 0,
    brand: item.brand || '',
    stockQuantity: item.stockQuantity || 0,
    weight: item.weight || '',
    length: item.length || '',
    width: item.width || '',
    height: item.height || '',
    barcode: item.barcode || '',
    tags: item.tags || [],
    hasVariants: item.hasVariants || false,
  });
  const merchandisePageId = item.merchandisePageId;
  console.log('merchpageid:', merchandisePageId)

  const [categoryName, setCategoryName] = useState(""); // Selected or new category

  const { data, loading: cloading, error: cerror } = useQuery(GET_CATEGORIES, {
      variables: { merchandisePageId },
    });

  const [editItem, { loading, error }] = useMutation(EDIT_MERCH_ITEM, {
    context: {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    },
    onCompleted: () => {
      if (onSuccess) onSuccess();
    },
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const input = {
      ...formData,
      price: parseFloat(formData.price),
      stockQuantity: parseInt(formData.stockQuantity, 10),
      weight: parseFloat(formData.weight) || null,
      length: parseFloat(formData.length) || null,
      width: parseFloat(formData.width) || null,
      height: parseFloat(formData.height) || null,
    };

    try {
      await editItem({ variables: { input } });
    } catch (err) {
      console.error('Edit failed:', err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className='edit-form-container '>
      <h2>Edit Merchandise Item</h2>
      <label>Title</label>
      <input name="title" value={formData.title} onChange={handleChange} placeholder="Title" required />
      <label>Description</label>
      <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Short description" />
      <label>Long Description</label>
      <textarea name="longDescription" value={formData.longDescription} onChange={handleChange} placeholder="Long description" />
      <label>Price</label>
      <input name="price" value={formData.price} onChange={handleChange} placeholder="Price" type="number" step="0.01" required />
      <label>Stock Quantity</label>
      <input name="stockQuantity" value={formData.stockQuantity} onChange={handleChange} placeholder="Stock Qty" type="number" />
      <input name="brand" value={formData.brand} onChange={handleChange} placeholder="Brand" />
      <input name="barcode" value={formData.barcode} onChange={handleChange} placeholder="Barcode" />
      
      
      
      <input name="weight" value={formData.weight} onChange={handleChange} placeholder="Weight (kg)" />
      <input name="length" value={formData.length} onChange={handleChange} placeholder="Length (cm)" />
      <input name="width" value={formData.width} onChange={handleChange} placeholder="Width (cm)" />
      <input name="height" value={formData.height} onChange={handleChange} placeholder="Height (cm)" />
      <label>
        Has Variants?
        <input name="hasVariants" type="checkbox" checked={formData.hasVariants} onChange={handleChange} />
      </label>
      <button type="submit" disabled={loading}>Save</button>
      {error && <p style={{ color: 'red' }}>Error: {error.message}</p>}
    </form>
  );
};

export default EditMerchandiseItemForm;
